export default function Mission() {
    return (
        <section
            data-testid="mission-section"
            className="py-24 md:py-32 bg-brand-cream relative"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-4">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="w-10 h-px bg-brand-gold" />
                            <span className="text-[10px] tracking-[0.4em] uppercase text-brand-gold-deep">
                                Mission
                            </span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl text-brand-black leading-tight">
                            Trust, timed
                            <br />
                            to the minute.
                        </h2>
                    </div>

                    <div className="md:col-span-8 md:pl-12">
                        <p className="font-serif text-2xl md:text-3xl leading-[1.4] text-brand-black/85 italic">
                            “SheFleet Transportation exists to exceed customer expectations by
                            providing timely, secure, and professional medical courier services.
                            We are dedicated to building trust, supporting our local community,
                            and driving success — one delivery at a time.”
                        </p>

                        <div className="mt-12 pt-12 border-t border-brand-black/10 grid sm:grid-cols-2 gap-10">
                            <div>
                                <div className="text-[10px] tracking-[0.3em] uppercase text-brand-gold-deep mb-3">
                                    Purpose
                                </div>
                                <p className="text-base text-brand-black/75 leading-relaxed">
                                    To ensure goods reach people safely and reliably, while
                                    connecting communities with the essential care they depend on.
                                </p>
                            </div>
                            <div>
                                <div className="text-[10px] tracking-[0.3em] uppercase text-brand-gold-deep mb-3">
                                    Promise
                                </div>
                                <p className="text-base text-brand-black/75 leading-relaxed">
                                    Chain-of-custody integrity, HIPAA-aware handling, and
                                    professional drivers — every route, every time.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
